module.exports = __webpack_public_path__ + "img/contact_email.0892956a.png";